export default class AitiCoreClientGtm {

    dataLayerVariableName: string;

    init(dataLayerVariableName: string) {
        this.dataLayerVariableName = dataLayerVariableName;
        window[this.dataLayerVariableName] = window[this.dataLayerVariableName] || [];
        return this;
    }

    getDataLayer(): any[] {
        return window[this.dataLayerVariableName];
    }

    push(...args: any[]) {
        this.getDataLayer().push(arguments);
    }
}
